import React, { useCallback, useState } from 'react';
import { Dropdown, Input, Button } from 'freemium-ui';
import Icons from 'components/icons';
import { surveyState } from 'shared/constants';
import { debounce, omit } from 'lodash';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import EmptyState from 'shared/emptyState';
import { GoToRouteType } from 'shared/types';

type propHeaderType = {
  setPageFilters: Function;
  pageFilters: any;
  setPageIndex: Function;
  setPageToken: Function;
  setIsFilterApplied: Function;
  isLoading: Boolean;
};

interface IState {
  id: string;
  label: string;
}

const ListHeader = (props: propHeaderType) => {
  const {
    setPageFilters,
    pageFilters,
    setPageIndex,
    setPageToken,
    setIsFilterApplied,
    isLoading,
  } = props;
  const [selectedSurveyState, setSelectedSurveyState] = useState<
    IState | null | any
  >(surveyState[0]);
  const [searchTerm, setSearchTerm] = useState<string>('');

  const handleSurveyStateChange = (selected: IState) => {
    setPageToken({});
    if (selected.id !== 'all') {
      setPageToken({});
      setIsFilterApplied(true);
      setPageFilters({ ...pageFilters, state: selected.id });
      setTimeout(() => {
        setIsFilterApplied(false);
      }, 100);
      setPageIndex(0);
    } else {
      setPageToken({});
      setPageFilters(
        pageFilters.state ? omit(pageFilters, ['state']) : pageFilters,
      );
      setPageIndex(0);
    }
    setSelectedSurveyState(selected);
  };

  const debouncedSearch = useCallback(
    debounce((param) => {
      setPageToken({});
      setIsFilterApplied(true);
      setPageFilters({ ...pageFilters, term: param });
      setTimeout(() => {
        setIsFilterApplied(false);
      }, 100);
      setPageIndex(0);
    }, 500),
    [],
  );

  const handleSearchChange = (e: any) => {
    const { value } = e.target;
    setSearchTerm(value);
    if (value.trim().length) debouncedSearch(value);
    else if (Object.keys(pageFilters).length) {
      setPageToken({});
      setPageFilters(omit(pageFilters, ['term']));
      setPageIndex(0);
    }
  };

  return (
    <div className="filter-bar">
      <div className="left-section">
        <Dropdown
          disabled={!!isLoading}
          width="120px"
          defaultSelectedItem={selectedSurveyState}
          items={surveyState}
          itemToString={(item: IState) => item.label}
          overrideButtonStyles={{
            background: 'linear-gradient(180deg,#fff,#f5f7f9)',
            minHeight: '34px',
            fontWeight: '500',
          }}
          onChange={(item: IState) => handleSurveyStateChange(item)}
        />
        <Input
          disabled={!!isLoading}
          startAdornment={
            <div style={{ paddingLeft: '12px' }}>
              <Icons glyph="search" size="18" viewBox="0 0 20 10" />
            </div>
          }
          placeholder="Search surveys by name"
          type="text"
          onChange={(e: any) => handleSearchChange(e)}
          maxLength={50}
          defaultValue={searchTerm}
        />
      </div>
    </div>
  );
};

export default ListHeader;

type EmptyStateProps = {
  pageFilters: any;
  goToRoute: GoToRouteType;
  isSavingSurveyState: boolean;
};

export const ListEmptyState = (props: EmptyStateProps) => {
  const { pageFilters, goToRoute, isSavingSurveyState } = props;
  const history: History = useHistory();
  return (
    <EmptyState
      title={
        pageFilters?.term
          ? `No surveys match your search ${pageFilters?.term} !`
          : 'No surveys here!'
      }
      message={
        pageFilters?.term
          ? 'Please try again with a different keyword.'
          : `You don't have any surveys in this view.`
      }
      imgSrc="empty-state-survey.svg"
    >
      {!pageFilters?.term ? (
        <Button
          inline
          disabled={isSavingSurveyState}
          onClick={() => {
            goToRoute({ path: '/survey/create', history });
          }}
        >
          + New Survey
        </Button>
      ) : null}
    </EmptyState>
  );
};
